export default class ShipmentsDetailsInCondition62And305 {
    constructor(warehouseId, shipmentId, encryptedShipmentId, orderId, asin, quantity, orderDate, promisedShipDate, shipMethod, expectedShipDate, condition, conditionAge, hoursPassedExsd, action, shipmentType) {
        this.warehouseId = warehouseId;
        this.shipmentId = shipmentId;
        this.encryptedShipmentId = encryptedShipmentId;
        this.orderId = orderId;
        this.asin = asin;
        this.quantity = quantity;
        this.orderDate = orderDate;
        this.promisedShipDate = promisedShipDate;
        this.shipMethod = shipMethod;
        this.expectedShipDate = expectedShipDate;
        this.condition = condition;
        this.conditionAge = conditionAge;
        this.hoursPassedExsd = hoursPassedExsd;
        this.action = action;
        this.shipmentType = shipmentType;
    }
}
